import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Footer, MobileBar } from "./components/Footer";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import About from "./pages/About";
import Contact from "./pages/Contact";
import GetQuote from "./pages/GetQuote";
import Gallery from "./pages/Gallery";
import Review from "./pages/Review";
import AreaPage from "./pages/AreaPage";
import ServiceAreasPage from "./pages/ServiceAreasPage";
import { Intro } from "./components/LogoIntro";
import { ReviewPopup } from "./components/ReviewPopup";
import AdminApp from "./admin/AdminApp";
import { ADMIN_BASE } from "./admin/api";

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PublicSite = () => (
  <>
    <SmoothScroll />
    <Intro />
    <Header />
    <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/roofing" element={<ServicePage key="roofing" slug="roofing" />} />
          <Route path="/siding" element={<ServicePage key="siding" slug="siding" />} />
          <Route path="/gutters" element={<ServicePage key="gutters" slug="gutters" />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/review" element={<Review />} />
          <Route path="/service-areas" element={<ServiceAreasPage />} />
          <Route path="/service-areas/:town" element={<AreaPage key="town" />} />
          <Route path="/roofing/:town" element={<AreaPage key="roofing" service="roofing" />} />
          <Route path="/siding/:town" element={<AreaPage key="siding" service="siding" />} />
          <Route path="/gutters/:town" element={<AreaPage key="gutters" service="gutters" />} />
          <Route path="/storm-damage" element={<ServicePage key="storm-damage" slug="storm-damage" />} />
          <Route path="/storm-damage/:town" element={<AreaPage key="storm-damage" service="storm-damage" />} />
          <Route path="/get-quote" element={<GetQuote />} />
          <Route path="*" element={<Home />} />
        </Routes>
    <Footer />
    <MobileBar />
    <ReviewPopup />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path={`${ADMIN_BASE}/*`} element={<AdminApp />} />
          <Route path="*" element={<PublicSite />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
